import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ComplaintsPage from './components/ComplaintsPage';
import ComplaintDetail from './components/ComplaintDetail';
import ScrollToTopButton from './components/ScrollToTopButton';
import SubmitComplaintPage from './components/SubmitComplaint';
import EmployeeRightsPage from './components/EmployeeRightsPage';
import './css/App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* <Header /> */}
        <Navbar />
        <main className="main-content container no-margin-top">
          <Routes>
            <Route path="/" element={<ComplaintsPage />} />
            <Route path="/submit-complaint" element={<SubmitComplaintPage />} />
            <Route path="/complaints/:id" element={<ComplaintDetail />} />
            <Route path="/employee-rights" element={<EmployeeRightsPage />} />
          </Routes>
        </main>
        <ScrollToTopButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
